<template>
	<div>
		<!-- 查看评审 -->
		<div v-show="!userTitle">
			<div class="header">当前评审进度统计</div>
			<el-table :header-cell-style="tableStyle" border ref="multipleTable" :data="topicList" style="width: 100%">
				<el-table-column prop="name" label="专家名称">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="rowBtn(scope.row)">{{ scope.row.name }}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="手机/电话"></el-table-column>
				<el-table-column prop="groupName" label="所属评审组"></el-table-column>
				<el-table-column prop="toReviewDeclareNumber" label="应评数量"></el-table-column>
				<el-table-column prop="hasReviewDeclareNumber" label="已评数量"></el-table-column>
				<el-table-column prop="residueDeclareNumber" label="剩余数量"></el-table-column>
				<el-table-column prop="isSubmit" label="是否提交评分">
					<template slot-scope="scope">
						{{ scope.row.isSubmit == 0 ? '未提交' : '已提交' }}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 评审详情 -->
		<div v-show="userTitle">
			<div class="header">
				<div class="col-ter">
					<span>专家评审详细信息</span>
					<div style="margin-left: 20px;">
						(专家姓名：
						<span style="color: red;">{{ userTitle }}</span>
						)
					</div>
				</div>
				<div class="col-ter" style="margin-top: 20px;">
					<div class="col-ter">
						<span class="col-tit">材料名称：</span>
						<el-input v-model="selectObj.name" clearable></el-input>
					</div>
					<div class="col-ter" style="margin-left: 100px;">
						<span class="col-tit">评审分值：</span>
						<el-input v-model="selectObj.school" clearable></el-input>
						<!-- 		<el-select v-model="selectObj.school" clearable placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select> -->
					</div>
					<el-button type="primary" style="margin-left: 20px;" @click="getUserTable">查询</el-button>
				</div>
			</div>
			<el-table id="table" :header-cell-style="tableStyle" border ref="multipleTable" :data="topicList2" style="width: 100%">
				<el-table-column prop="declareName" label="材料/名称">
					 <!-- @click="rowBtn(scope.row)" -->
					<template slot-scope="scope">
						<!-- color: #66b1ff; -->
						<div style="cursor: default;">{{ scope.row.declareName }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="learningTypeName" label="所属学校" width="200"></el-table-column>
				<el-table-column prop="disciplineName" label="所属评审组" width="120"></el-table-column>
				<el-table-column prop="score" label="得分" width="80"></el-table-column>
				<el-table-column label="操作" width="100">
					<template v-slot:default="scope">
						<el-button type="text" @click="goRoute(scope.row)">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top: 20px;">
				<el-button type="primary" @click="exportExcel">导出Excel</el-button>
				<el-button type="primary" style="margin-left: 20px;" @click="userTitle = ''">返回</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { reviewProgressList, reviewProgressInfo1 } from '@/api/after/newInterface.js';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
export default {
	data() {
		return {
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#7e9be2',
				color: '#fff'
			},
			topicList: [],
			// 详情
			detailedList: [{ declareName: '详情' }],
			userTitle: '',
			selectObj: {
				name: '',
				school: ''
			},
			projectId: '',
			topicList2: [],
			userId: ''
		};
	},
	mounted() {
		this.projectId = sessionStorage.getItem('projectId');
		this.getTable();
	},
	methods: {
		goRoute(row) {
			this.$router.push(`/backstage/IndividualScore?id=${row.id}&projectId=${this.projectId}&userId=${this.userId}&score=${row.score}&note=${row.note}`);
		},
		// 导出excel
		exportExcel() {
			let exportFileName = '专家作品.xlsx';
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			console.log(wb, 'wb');
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), exportFileName);
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		//专家名称btn
		rowBtn(row) {
			this.userTitle = row.name;
			this.userId = row.userId;
			this.getUserTable();
		},
		//talbe
		getTable() {
			reviewProgressList({ pageNumber: 1, pageSize: 999, id: this.projectId }).then(res => {
				if (res.code == 200) {
					this.topicList = res.data.records;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getUserTable() {
			let params = {
				userId: this.userId,
				settingId: this.projectId,
				name: this.selectObj.name,
				source: this.selectObj.school
			};
			reviewProgressInfo1(params).then(res => {
				if (res.code == 200) {
					this.topicList2 = res.data.infoList;
				} else {
					this.$message.error(res.msg);
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.header {
	font-weight: bold;
	font-size: 20px;
	margin-bottom: 20px;
}
.col-ter {
	display: flex;
	align-items: center;
}
.col-tit {
	color: #7e9be2;
	min-width: max-content;
}
</style>
